let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let FormUtils = require("../../../../../utils/FormUtils");
let createStandardEventForm = require("../../createStandardEventForm");

let DaForm = createStandardEventForm({
	eventToInitialValues(event){
		return {
			month: esUtils.getIn(event, ["key_values", "UNSCHEDULED_MONTH"]),
			year:  esUtils.getIn(event, ["key_values", "UNSCHEDULED_YEAR"])
		};
	},
	buildSchema(){
		let curr_year = (new Date()).getFullYear();
		return {
			month: {
				label: "Month",
				type: "select",
				dont_sort_options: true,
				options: _.object(_.map(_.range(1, 13), function(m){
					return [m, esUtils.get_month_name(m)];
				})),
				validate: FormUtils.v.blankOr(FormUtils.v.positive_integer)
			},
			year: {
				label: "Year",
				type: "select",
				dont_sort_options: true,
				options: _.object(_.map(_.range(curr_year - 1, curr_year + 5), function(y){
					return [y, y];
				})),
				validate: FormUtils.v.positive_integer
			}
		};
	},
	writeInputDataToEvent(data, event){
		if(!_.isPlainObject(event.key_values)){
			event.key_values = {};
		}
		event.key_values.UNSCHEDULED_MONTH = esUtils.toInt(data.month);
		event.key_values.UNSCHEDULED_YEAR = esUtils.toInt(data.year);
	}
});

module.exports = dd.createClass({
	render(){
		if(!_.isEmpty(this.props.event.Stagetime)){
			return dd.span();//nothing to see
		}
		return DaForm(_.assign({
			form_section_name: "Unscheduled Event"
		}, this.props));
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/services/UnscheduledEventEstimatedMonthAndYear.js